export const i18nPdfPage = {
  headerTitle: 'Informe de seguimiento del rendimiento',
  headerSubtitle: 'Equipo rotativo',
  system: 'Sistema/Subsistema',
  dimensions: 'Dimensiones',
  cd: 'Desviación de condiciónes',
  coverTitle: 'Monthly Report',
  category: { RERT: 'Rotating equipment' },
  cover: {
    documentNumber: 'Document Number',
    issueReason: 'Issuer Reason',
    revision: 'Revision',
  },
  caption: {
    critical: 'Condición crítica',
    potencial: 'Problema potencial',
    alarm: 'Condición de alarma',
    normal: 'Normal',
    notMonitored: 'No monitoreado',
    notOperated: 'No operado',
  },
  normal: 'estaba normal',
  label: {
    diagnosis: 'Diagnóstico',
    detailing: 'Detallando',
    deviationStart: 'Inicio de desviación',
    deviationEnd: 'Fin de desviación',
    conditionEvaluation: 'Evaluación de la condición',
    recommendedAction: 'Acción recomendada',
    actionStatus: 'Estado de la acción',
    sapNote: 'Nota SAP / Estado',
  },
  dimensions_label: {
    dynamic_condition: 'Condición dinámica',
    auxiliary_system: 'Sistema auxiliar',
    oil_analysis: 'Análisis de aceite',
    process_condition: 'Condición del proceso',
  },
  summary: {
    cases: {
      title: 'Casos',
      total: 'Total',
    },
    severity: {
      title: 'Severidad',
      very_high: 'Muy alto',
      high: 'Alto',
      medium: 'Medio',
      low: 'Bajo',
      very_low: 'Muy bajo',
    },
    stage: {
      title: 'Etapa',
      diagnosis: 'Diagnóstico',
      actions: 'Acciones',
      feedback: 'Respuesta',
      closed: 'Cerrado',
    },
  },
};
